function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgEmail = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 256 256"
}, props), /*#__PURE__*/React.createElement("g", {
  style: {
    stroke: "none",
    strokeWidth: 0,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "nonzero",
    opacity: 1
  },
  transform: "matrix(2.81 0 0 2.81 1.407 1.407)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M80.89 78.772H9.11c-5.023 0-9.11-4.087-9.11-9.11V20.338c0-5.023 4.087-9.11 9.11-9.11h71.78c5.023 0 9.11 4.087 9.11 9.11v49.324c0 5.024-4.087 9.11-9.11 9.11zM9.11 17.228A3.114 3.114 0 0 0 6 20.338v49.324a3.113 3.113 0 0 0 3.11 3.11h71.78a3.114 3.114 0 0 0 3.11-3.11V20.338a3.114 3.114 0 0 0-3.11-3.11H9.11z",
  style: {
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    fill: "currentColor",
    fillRule: "nonzero",
    opacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M45 55.427a19.313 19.313 0 0 1-14.242-6.288L2.493 18.125l4.435-4.042 28.265 31.013c2.545 2.792 6.028 4.331 9.807 4.331 3.779 0 7.262-1.538 9.808-4.331l28.266-31.013 4.434 4.042-28.267 31.013A19.307 19.307 0 0 1 45 55.427z",
  style: {
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    fill: "currentColor",
    fillRule: "nonzero",
    opacity: 1
  }
}), /*#__PURE__*/React.createElement("rect", {
  width: 38.98,
  height: 6,
  x: -0.96,
  y: 57.16,
  rx: 0,
  ry: 0,
  style: {
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    fill: "currentColor",
    fillRule: "nonzero",
    opacity: 1
  },
  transform: "rotate(-45.146 18.528 60.161)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 38.98,
  x: 68.47,
  y: 40.67,
  rx: 0,
  ry: 0,
  style: {
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    fill: "currentColor",
    fillRule: "nonzero",
    opacity: 1
  },
  transform: "rotate(-44.85 71.466 60.158)"
})));
export default SvgEmail;